import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommentDialogComponent } from 'src/app/dialogs';
import { TopicType } from 'src/app/enums/topic-type.enum';
import { CommentConfig } from 'src/app/models/comment-config.model';
import { CommentDialogData } from 'src/app/models/dialog/comment-dialog-data.model';
import { GoalPeriodCustomGoal } from 'src/app/models/goal-period-custom-goal.model';
import { GoalPeriod } from 'src/app/models/goalperiod.model';
import { ReviewPeriodCustomGoal } from 'src/app/models/review-period-custom-goal.model';
import { State } from 'src/app/models/state.model';
import { GoalService, StateService } from 'src/app/services';
import { Comment } from 'src/app/models/comment.model';
import { CommentService } from 'src/app/services/comment.service';
import { ErrorMessageService } from 'src/app/shared/services';
import { IResultModel, ResultModel } from 'src/app/models/general/result.model';
import { GoalPermissionsHelper } from 'src/app/helpers/goal-permissions.helper';

@Component({
  selector: 'app-goal-custom-goals',
  templateUrl: './goal-custom-goals.component.html',
  styleUrl: './goal-custom-goals.component.scss'
})
export class GoalCustomGoalsComponent {

  @Input()
  public reviewPeriodCustomGoal: ReviewPeriodCustomGoal;

  @Input()
  public goalPeriod: GoalPeriod;

  public state: State;

  public get getOwnComment(): Comment {
    return this.reviewPeriodCustomGoal.customGoal?.comments.find(c => c.employeeId === this.state.me.value.employee.id) ?? null;
  }

  constructor(stateService: StateService, 
    private dialog: MatDialog, 
    private commentService: CommentService,
    private goalService: GoalService,
    private msgService: ErrorMessageService) {
      this.state = stateService.state;
  }

  public createCommentConfig(): CommentConfig {
      return {
          employeeId: this.state?.me.value?.employee?.id ?? 0,
          topicId: TopicType.GoalPeriodCustomGoals,
          topicRef: this.reviewPeriodCustomGoal.customGoal?.id,     // goalPeriodCustomGoalId
      } as CommentConfig;
  }

    public allowComment(): boolean {
      return GoalPermissionsHelper.canCommentToCustomGoals(this.goalPeriod, this.state, this.reviewPeriodCustomGoal);
    }

    onComment(): void {
      this.showCommentDialog();    
    }
    
    public showCommentDialog()
    {

        let dialogData: CommentDialogData = {
          topicId: TopicType.GoalPeriodCustomGoals, 
          topicRef: this.reviewPeriodCustomGoal.customGoal?.id,
          noSave: true,
          comment: this.getOwnComment ? {...this.getOwnComment } : null,
        };
    
        const dialogRef = this.dialog.open(CommentDialogComponent, {
          minWidth: "500px",
          data: dialogData,
        });
    
        dialogRef.afterClosed().subscribe( (dialogResult: Comment) => {
          if (dialogResult)
          {
              this.handleDialogResult(dialogResult);
          }
          
        });
    }

    public handleDialogResult(comment: Comment) {
        if (!comment.message)
        {
          if (comment.id)
          {
            this.deleteComment(comment.id);
          }
        }
        else {
          if (this.reviewPeriodCustomGoal.customGoal?.id)
          {
            if (comment.id) {
              this.updateComment(comment);
            }
            else
              this.insertComment(comment);
          }
          else {
            this.insertCustomGoal(comment);
          }
        }
    }

    public deleteComment(commentId: number) {
      this.commentService.deleteComment(commentId).subscribe({
        next: () => {

          //remove comment from list
          this.reviewPeriodCustomGoal.customGoal.comments = this.reviewPeriodCustomGoal.customGoal.comments.filter(c => c.id !== commentId);
        },
        error: (err: IResultModel<ResultModel>) => {
          this.msgService.handleError<ResultModel>(err);
        }
      });
    }

    public updateComment(comment: Comment) {
      this.commentService.updateComment(comment).subscribe({
        next: (result) => {
          const index = this.reviewPeriodCustomGoal.customGoal.comments.findIndex(c => c.employeeId === comment.employeeId);
          this.reviewPeriodCustomGoal.customGoal.comments[index] = result.data;
        },
        error: (err: IResultModel<ResultModel>) => {
          this.msgService.handleError<ResultModel>(err);
        }
      });
    }

    public insertComment(comment: Comment) {
      this.commentService.insertComment(comment).subscribe({
        next: (result) => {
          let resultComment = result.data;
          resultComment.author = this.state?.me.value?.employee?.name;
          this.reviewPeriodCustomGoal.customGoal.comments.push(resultComment);
        },
        error: (err: IResultModel<ResultModel>) => {
          this.msgService.handleError<ResultModel>(err);
        }
      });
    }

    public insertCustomGoal(comment: Comment) {
        const customGoal = this.reviewPeriodCustomGoal.customGoal ?? {comments: [], 
                                                 goalPeriodId: this.goalPeriod.id, 
                                                 goalPeriodState: this.goalPeriod.status, 
                                                 reviewPeriodCustomGoalId: this.reviewPeriodCustomGoal.id } as GoalPeriodCustomGoal;

        customGoal.comments.push(comment);

        this.goalService.insertGoalPeriodCustomGoal(customGoal).subscribe({
          next: (result) => {
            this.reviewPeriodCustomGoal.customGoal = result.data;
          },
          error: (err: IResultModel<ResultModel>) => {
            this.msgService.handleError<ResultModel>(err);
          }
        });
    }
}
